import { render } from "./SVGWrapper.vue?vue&type=template&id=025dd70f"
import script from "./SVGWrapper.vue?vue&type=script&lang=js"
export * from "./SVGWrapper.vue?vue&type=script&lang=js"

import exportComponent from "/Users/umar/Desktop/umi-portfolio-2021/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__